(() => {
  if (customElements.get('rss-sign-fixings')) return;
  customElements.define('rss-sign-fixings', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-fixing-choice]')) return;
        const card = event.target.closest('[data-fixing-card]');
        const id = event.target.value;
        const template = [...card.querySelectorAll('[data-fixing-price-id]')].find(node => node.dataset.fixingPriceId === id);
        if (template) card.querySelector('[data-fixing-price]').replaceChildren(template.content.cloneNode(true));
        const button = card.querySelector('[data-fixing-add]');
        button.dataset.fixingAdd = id;
        button.disabled = !id;
      }, options);
      this.addEventListener('click', event => {
        const scroll = event.target.closest('[data-fixing-scroll]');
        if (scroll) this.querySelector('.rss-fixing-list')?.scrollBy({ left: Number(scroll.dataset.fixingScroll) * this.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const button = event.target.closest('[data-fixing-add]');
        if (button) {
          event.preventDefault();
          event.stopPropagation();
          this.add(button);
        }
      }, options);
      this.scope = this.closest('.shopify-section');
      this.scope?.addEventListener('change', event => {
        if (!event.target.closest('variant-selects, variant-radios') && !event.target.matches('input[name="id"]')) return;
        if (event.target.closest('rss-sign-fixings')) return;
        this.pending = true;
        this.hidden = true;
      }, options);
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe('product:variant-change', data => {
          if (String(data.sectionId) !== this.dataset.sectionId) return;
          const current = document.getElementById('product-form-' + this.dataset.sectionId)?.querySelector('[name="id"]')?.value;
          if (current && String(data.variant?.id) !== current) return;
          const replacement = data.html?.getElementById(this.id);
          if (replacement) this.replaceWith(replacement.cloneNode(true));
        });
      }
      const list = this.querySelector('.rss-fixing-list');
      if (list) {
        this.resizeObserver = new ResizeObserver(() => this.navigation());
        this.resizeObserver.observe(list);
        list.addEventListener('scroll', () => this.navigation(), options);
        this.navigation();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.resizeObserver?.disconnect();
    }
    navigation() {
      const list = this.querySelector('.rss-fixing-list');
      const navigation = this.querySelector('.rss-fixing-navigation');
      if (!list || !navigation) return;
      navigation.hidden = list.scrollWidth <= list.clientWidth + 2;
      navigation.querySelector('[data-fixing-scroll="-1"]').disabled = list.scrollLeft <= 2;
      navigation.querySelector('[data-fixing-scroll="1"]').disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    async add(button) {
      if (this.busy || this.pending || !button.dataset.fixingAdd) return;
      const card = button.closest('[data-fixing-card]');
      const quantity = card.querySelector('[data-fixing-quantity]');
      if (!quantity.reportValidity() || !Number.isSafeInteger(Number(quantity.value))) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const label = button.textContent;
      const status = card.querySelector('.rss-fixing-status');
      const selected = card.querySelector('[data-fixing-choice]');
      const itemName = card.querySelector('h3').textContent.trim() + (selected ? ' — ' + selected.selectedOptions[0].textContent.trim() : '');
      const addedMessage = this.dataset.added + ': ' + quantity.value + ' × ' + itemName;
      const variantId = Number(button.dataset.fixingAdd);
      const requestedQuantity = Number(quantity.value);
      const controls = [...this.querySelectorAll('button, select, input')].map(control => [control, control.disabled]);
      controls.forEach(([control]) => { control.disabled = true; });
      button.textContent = this.dataset.adding;
      status.hidden = true;
      let added = false;
      try {
        const mini = document.querySelector('mini-cart');
        const sections = mini?.getSectionsToRender?.().map(section => section.section) || [];
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: requestedQuantity }], ...(sections.length ? { sections, sections_url: location.pathname } : {}) })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        added = true;
        if (mini && sections.length) {
          try {
            if (sections.every(section => result.sections?.[section])) mini.renderContents(result);
            else await mini.updateSectionContents();
          } catch {
            mini.updateSectionContents().catch(() => {});
          }
        }
        status.textContent = addedMessage;
        status.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: result.items, context: 'SignFixings' } }));
        if (typeof publish === 'function') publish('cart:item-add', { source: 'SignFixings', items: result.items });
      } catch (error) {
        status.textContent = added ? addedMessage : error.message || this.dataset.error;
        status.hidden = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        controls.forEach(([control, disabled]) => { control.disabled = disabled; });
        button.textContent = label;
        this.navigation();
      }
    }
  });
})();
